<template>
  <v-app>
    <v-content class="container-fluid auth-container">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-card-media id="imageLogo" src="/static/img/amexLogo.jpg" height="35vh"></v-card-media>
              <!-- <v-card-media > -->
                <!-- <img id="imageLogo" style="height:35vh;" src="/static/img/logos/icon_256x256@2x.png"/> -->
              <!-- </v-card-media> -->
              <v-card-text>
                <router-view></router-view>
              </v-card-text>
              <v-card-actions>
                <!-- <v-subheader><strong>&copy;</strong>{{$t("view.home.footer.copyRight")}}</v-subheader>
                <v-spacer></v-spacer>
                <v-subheader class="auth-footer__copyright">{{$t("view.home.footer.sistema")}}</v-subheader> -->
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<!-- Implementation Script -->
<script>
import Auth from "@/services/auth";
import * as actions from "@/constants/mutation-names";
import {errors} from "@/locales/languages/es_MX";
import {valueIsWithin} from "@/helpers/validators";
import {allValidatorMethods} from "@/helpers/vuelidate"
import transform from "@/helpers/transformations";
import {AuthenticationModel} from "@/models/authentication";
import es from 'vee-validate/dist/locale/es';
import {required, minLength} from "vuelidate/lib/validators";
import VueContentLoading from 'vue-content-loading';

// List of errors required for login flow
const errorsAPILogin = Object.keys(errors.login);
const errorsExpiredPassword = Object.keys(errors.expiredPassword);

//Initial Model
const auth = new AuthenticationModel();

export default {
  name: "Authentication",
  head:{
  }
  , data() {
    let _locale = this.$i18n.locale;
    return {
      auth
      , locale: _locale
      , view:{
        title:"Login"
        , action:{
          login:{
            busy:false
          }
        }
        , loginErrorMessage:{
            visible: false
          , text   : ""
        }
        , loginButton:{
          enable:true
        }
      }
    };
  }
  ,methods: {
    async logIn() {
      try{
        // Hide any previous error
        this.hideErrorResetPassword();
        // Validate all models before make the request
        if(!this.isAllValid(this.$v)){
          return;
        }
        
        this.view.action.login.busy=true;
        const response = await Auth.logIn(this.auth);
        this.view.action.login.busy=false;
        let {data:{results:{token:userToken, usuario}}} = response;
        // Transform data for store login action
        const data = {...transform.ResponseToUserStore(usuario), userToken};  
        // Saving data state on store
        this.$store.dispatch(actions.AUTH_LOGIN,data);
        //Login success, route to home
        this.$router.push("/home");
      }catch(error){
        //Finish busy flag for login action
        this.view.action.login.busy=false;
        //Handling error protocols
        if(error && error.status=="500"){
          this.showErrorMessage(this.$t(`network.errors.${error.status}.desc`));
          return;
        }
        // Extract errorCode
        const {data:{meta:{code:errorCode}}} = error;
        // Login's error
        if(valueIsWithin(errorsAPILogin,errorCode))
          this.showErrorMessage(this.$t(`errors.login.${errorCode}.text`));
        // Password Expired's error
        if(valueIsWithin(errorsExpiredPassword,errorCode)){
          this.$router.push({ name: 'MessageScreen', params: { username: this.auth.username }})
        }
      }
      event.target.disabled = false;
    }
    , switchLanguage(){
      if(this.locale === "es"){
        this.$store.dispatch(actions.APP_SET_LANGUAGE,'en');
        //this.$validator.localize('en');
      }else{
        this.$store.dispatch(actions.APP_SET_LANGUAGE,'es');
        //this.$validator.localize('es', es);
      }
      this.locale = this.$i18n.locale;
    }
    , isSetLanguage(language){
      return this.locale==language
    }
    , setInitialState(){
      document.querySelector('#imageLogo').style.height = "35vh";
    }
  }
  , computed:{
    loginErrorMessage(){
      return this.view.loginErrorMessage.text
    }
  }
  // Instance Lifecycle Hooks
  , created(){
    this.setInitialState();
  }
};
</script>
<!-- Style scoped Implementation -->
<style scoped>
.auth-container{
  position: absolute;
  right: 0;
  top:0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color:white;
}
.login--error--label__margin{
  padding-bottom: 1em;
}
.login-submit__disable{
  background-color:#e6e6e6;
  border: 1px solid #d2d2d2;
  color: #676a6c;
}
/*.left--section:before{
  content:"";
  position: absolute;
  left:0;
  right: 0;
  top:0;
  bottom: 0;
  z-index: -1;
  display: block;
  width: 100%;
  background-image: url('/static/img/laboratory-b.jpg');
  background-size: cover;
  border-bottom-left-radius: 1px;
  border-top-left-radius: 1px;
  opacity: .9;
  border-radius: 10px 0px 0px 10px;
  -webkit-filter: blur(1px);
  -moz-filter: blur(1px);
  -o-filter: blur(1px);
  -ms-filter: blur(1px);
  filter: blur(1px);
}*/
.left-section{
  position:relative;
  margin: auto;
  width: 400px;
  max-width: 400px;
  height: 381px;
  top: 0; bottom:0; left:0; right:0;
  /*padding-top: 3em;
  padding-bottom: 3em;*/
  background-color: rgba(10, 10, 10, 0.2);
  border-radius: 10px 0px 0px 10px;
  color:white;
}

.left-section__fos-logo{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  max-height: 300px;
}
.auth-footer__copyright{
  position: absolute;
  right: 0;
  padding-right: 15px;
}
.right-section{
  padding-left: 0;
  padding-right: 0;
  background-color: white;
  border-radius: 0px 10px 10px 0px;
}
/* Media Query for small devices */
@media (min-width: 768px){
  .is-table-row {
    display:table;
  }
  .is-table-row [class*="col-"] {
    float: none;
    display: table-cell;
    vertical-align: top;
  }
  .auth-container:before{
    content:"";
    position: absolute;
    left:0;
    right: 0;
    top:0;
    bottom: 0;
    z-index: 0;
    display: block;
    width: 100%;
    background-image: url('/static/img/amex1.jpg');
    background-size:cover;
    /*border-bottom-left-radius: 1px;
    border-top-left-radius: 1px;*/
    -webkit-filter: blur(4px);
    -moz-filter: blur(4px);
    -o-filter: blur(4px);
    -ms-filter: blur(4px);
    filter: blur(4px);
    background-position: center;
    height: 100%;
  }
  .auth-container{
    position: absolute;
    right: 0;
    top:0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color:white;
  }
  .right-section--content{
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    /*margin: 0 auto;*/
    width: 100%;
    background-color: inherit;
    color: inherit;
    padding: 15px 20px 20px 20px;
  }
  .auth-footer{
    padding-top: 15px;
    color: white;
  }
}
/* Add to Global class */
.btn-primary[disabled]{
  background-color:#e6e6e6;
  border: 1px solid #d2d2d2;
  color: #676a6c;
}
/* Add to Global class */
.btn-primary[disabled]:hover{
  background-color:#e6e6e6;
  border: 1px solid #d2d2d2;
  color: #676a6c;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/Authentication.vue